import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = { class: "content-title" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = {
  class: "modal-body scroll-wrapper",
  ref: "modalBodyRef"
}
const _hoisted_5 = {
  key: 0,
  class: "content-house"
}
const _hoisted_6 = { class: "content-img-house-selected" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "content-details-house-selected" }
const _hoisted_9 = { class: "content-lot-features" }
const _hoisted_10 = { class: "lot-title" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "content-features" }
const _hoisted_13 = { class: "content-details-price" }
const _hoisted_14 = { class: "content-row" }
const _hoisted_15 = { class: "value-row" }
const _hoisted_16 = { class: "content-row" }
const _hoisted_17 = { class: "value-row bold" }
const _hoisted_18 = { class: "total bold" }
const _hoisted_19 = { class: "input-row form-group" }
const _hoisted_20 = { class: "input-wr" }
const _hoisted_21 = {
  key: 0,
  class: "error"
}
const _hoisted_22 = { class: "input-wr" }
const _hoisted_23 = {
  key: 0,
  class: "error"
}
const _hoisted_24 = { class: "input-row form-group" }
const _hoisted_25 = { class: "input-wr" }
const _hoisted_26 = {
  key: 0,
  class: "error"
}
const _hoisted_27 = { class: "input-wr" }
const _hoisted_28 = {
  key: 0,
  class: "error"
}
const _hoisted_29 = { class: "options-wr" }
const _hoisted_30 = { class: "input-row form-group" }
const _hoisted_31 = { class: "input-wr" }
const _hoisted_32 = { class: "input-wr" }
const _hoisted_33 = {
  class: "dropdown-button input-dropdown option-label",
  type: "button"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "controls" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = {
  key: 1,
  class: "spinner spinner-small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $setup.props.isOpen,
    onClose: $setup.onClose,
    classes: ['select-builder-quote-modal']
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, "Submit an enquiry with " + _toDisplayString($setup.props.builder.name), 1)
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "line" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        ($setup.props.house && $setup.props.lot)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  class: "img-house",
                  src: $setup.facade.url
                }, null, 8, _hoisted_7)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, "Lot " + _toDisplayString($setup.props.lot.title), 1),
                  ($props.builder)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "builder-logo",
                        src: $props.builder.logo
                      }, null, 8, _hoisted_11))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode($setup["HouseFeatures"], {
                    features: $setup.props.house,
                    directionLogoLandPackage: true,
                    iconSize: 'tiny-min',
                    class: _normalizeClass('house-features')
                  }, null, 8, ["features"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "label-row" }, "House area:", -1)),
                    _createElementVNode("div", _hoisted_15, _toDisplayString($setup.formatPrice($setup.props.house.area, false)) + " sqm", 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "label-row bold" }, "Build Price:", -1)),
                    _createElementVNode("div", _hoisted_17, [
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "from" }, "From", -1)),
                      _createElementVNode("div", _hoisted_18, _toDisplayString($setup.buildPriceWithFacade) + "*", 1)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "label bold" }, "First Name (required)", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "input-default",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.firstName) = $event)),
              placeholder: "First Name"
            }, null, 512), [
              [_vModelText, $setup.form.firstName]
            ]),
            ($setup.v$.firstName.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString($setup.v$.firstName.required.$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "label bold" }, "Last Name (required)", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "input-default",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.lastName) = $event)),
              placeholder: "Last Name"
            }, null, 512), [
              [_vModelText, $setup.form.lastName]
            ]),
            ($setup.v$.lastName.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString($setup.v$.lastName.required.$message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "label bold" }, "Phone (required)", -1)),
            _createVNode($setup["Cleave"], {
              class: "input-default",
              placeholder: $setup.phonePlaceholder,
              modelValue: $setup.form.phone,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.phone) = $event)),
              options: $setup.phoneNumberOption($setup.form.phone)
            }, null, 8, ["placeholder", "modelValue", "options"]),
            ($setup.v$.phone.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString($setup.v$.phone.$errors[0]?.$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "label bold" }, "Email (required)", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "input-default",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.email) = $event)),
              type: "email",
              placeholder: "Email"
            }, null, 512), [
              [_vModelText, $setup.form.email]
            ]),
            ($setup.v$.email.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString($setup.v$.email.required.$message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "label bold" }, "Message", -1)),
          _withDirectives(_createElementVNode("textarea", {
            class: "input-default scroll-wrapper",
            placeholder: "",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.message) = $event))
          }, null, 512), [
            [_vModelText, $setup.form.message]
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "label bold" }, "Preferred Lots", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "input-default",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.preferredLots) = $event)),
              placeholder: "e.g. Lot 12, Lot 14"
            }, null, 512), [
              [_vModelText, $setup.form.preferredLots]
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "label bold" }, "Finance status", -1)),
            _createVNode($setup["DropDown"], {
              class: "dropdown-container",
              onClick: $setup.onFinanceStatusDropdownClick
            }, {
              control: _withCtx(() => [
                _createElementVNode("label", _hoisted_33, _toDisplayString($setup.form.financeStatus), 1)
              ]),
              dropdown: _withCtx(() => [
                _createElementVNode("ul", null, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.optionsFinanceStatus, (status) => {
                    return _createElementVNode("li", {
                      key: status,
                      onClick: ($event: any) => ($setup.selectFinanceStatus(status)),
                      class: _normalizeClass({ 'dropdown__item-active': status === $setup.form.financeStatus })
                    }, _toDisplayString(status), 11, _hoisted_34)
                  }), 64))
                ])
              ]),
              _: 1
            })
          ])
        ])
      ], 512),
      _createElementVNode("div", _hoisted_35, [
        (!$setup.isLoading)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button default primary large long",
              disabled: $setup.isLoading,
              onClick: $setup.submitEnquiry
            }, "Submit enquiry", 8, _hoisted_36))
          : _createCommentVNode("", true),
        ($setup.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "button-cancel-border default large",
          onClick: $setup.onClose
        }, "Cancel")
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}